import React from 'react';

import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import SimplePopup from 'apps/auth/components/common/Popup/SimplePopup';
import { usePageMessages } from 'apps/auth/hooks/selectors';

const ChangeCountryCodePopup = ({ popupRef }) => {
    const { gotIt, errorPopupText } = usePageMessages();

    return (
        <SimplePopup text={errorPopupText} popupRef={popupRef}>
            <PopupButton onClick={() => popupRef.current?.close()} iconName="check" text={gotIt} />
        </SimplePopup>
    );
};
export default ChangeCountryCodePopup;
